export default __webpack_public_path__ + "static/media/taxefy_checkmark_2.6dedc273.png";